var _desc, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWechat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "wechat (2)") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "wechat-(2)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#09B83E",
    cx: 24,
    cy: 24,
    r: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(8.531250, 11.062500)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2816875,10.2463125 C16.205625,8.6041875 18.7558125,7.699875 21.4621875,7.699875 C21.7745625,7.699875 22.0847813,7.7124375 22.3922812,7.73634375 C21.3589688,3.3305625 16.8015,0.0110625 11.3352187,0.0110625 C5.10703125,0.0110625 0.05821875,4.32028125 0.05821875,9.6358125 C0.05821875,12.4120312 1.43596875,14.9131875 3.639,16.6697813 L2.72109375,20.8005938 L6.76546875,18.4369688 C8.16234375,18.9660938 9.70846875,19.2606563 11.3353125,19.2606563 C11.4670313,19.2606563 11.5980938,19.2579375 11.7287813,19.2541875 C11.4085313,18.3894375 11.2416563,17.476875 11.2416563,16.5409688 C11.2415625,14.1549375 12.3212813,11.9195625 14.2816875,10.2463125 Z M15.2975625,4.50253125 C16.0949063,4.50253125 16.7412187,5.1489375 16.7412187,5.9461875 C16.7412187,6.7434375 16.0948125,7.38984375 15.2975625,7.38984375 C14.5002188,7.38984375 13.8539062,6.7434375 13.8539062,5.9461875 C13.8539062,5.1489375 14.5002188,4.50253125 15.2975625,4.50253125 Z M7.1165625,7.39003125 C6.31921875,7.39003125 5.67290625,6.743625 5.67290625,5.946375 C5.67290625,5.149125 6.3193125,4.50271875 7.1165625,4.50271875 C7.9138125,4.50271875 8.56021875,5.149125 8.56021875,5.946375 C8.56021875,6.743625 7.91390625,7.39003125 7.1165625,7.39003125 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4622812,8.5036875 C16.2614063,8.5036875 12.045375,12.102 12.045375,16.540875 C12.045375,20.97975 16.2614063,24.5780625 21.4622812,24.5780625 C22.8207187,24.5780625 24.11175,24.3321562 25.2782812,23.8902187 L28.6555312,25.8639375 L27.8890313,22.4145937 C29.7287813,20.9476875 30.8791875,18.859125 30.8791875,16.540875 C30.8791875,12.102 26.6630625,8.5036875 21.4622812,8.5036875 Z M18.1535625,12.2543437 C18.819375,12.2543437 19.3590937,12.7940625 19.3590937,13.459875 C19.3590937,14.1256875 18.819375,14.6654062 18.1535625,14.6654062 C17.48775,14.6654062 16.9480312,14.1256875 16.9480312,13.459875 C16.9480312,12.7940625 17.4878437,12.2543437 18.1535625,12.2543437 Z M24.9852188,14.6655 C24.3194063,14.6655 23.7796875,14.1257812 23.7796875,13.4599688 C23.7796875,12.7941563 24.3194063,12.2544375 24.9852188,12.2544375 C25.6510312,12.2544375 26.19075,12.7941563 26.19075,13.4599688 C26.19075,14.1257812 25.6510312,14.6655 24.9852188,14.6655 Z",
    id: "Shape"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWechat);
export default __webpack_public_path__ + "static/media/wechat.c2caa3953cd16dbe100873d0bfa2c76f.svg";
export { ForwardRef as ReactComponent };